import { Campaign } from '@/models/reward';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsExtrasBody',
})
export default class CmgRewardsExtrasBody extends Vue {
    @Prop({ required: true, type: Array })
    campaigns!: Campaign[];

    get hasCampaigns(): boolean {
        return this.campaigns.length > 0;
    }
}
